'use client';

import Image from 'next/image';
import { useEffect, useMemo, useState } from 'react';
import s from './styles.module.scss';

export const SomeWeirdStuff = () => {
    const [vw, setVw] = useState<number | null>(null);

    useEffect(() => {
        const setWidth = () => setVw(window.innerWidth);
        setWidth();
        window.addEventListener('resize', setWidth);
        return () => window.removeEventListener('resize', setWidth);
    }, []);

    const timeline = useMemo(() => {
        const w = vw ?? 1920;
        if (w <= 790) {
            return { src: '/images/SomeWeirdStuff_mb.png', width: 363, height: 438 };
        }
        if (w <= 1060) {
            return { src: '/images/SomeWeirdStuff_tab.png', width: 710, height: 416 };
        }
        return { src: '/images/SomeWeirdStuff.png', width: 1060, height: 350 };
    }, [vw]);


    return (
        <div className={s.root}>
                <h2>
                    <span>RaceCamp</span> це <br />
                    про тебе, якщоooooо:
                </h2>

            <Image
                src={timeline.src}
                alt=""
                width={timeline.width}
                height={timeline.height}
                priority={false}
            />
        </div>
    );
};
